import { render, staticRenderFns } from "./constructionInsurance.vue?vue&type=template&id=ac4a29a4&"
import script from "./constructionInsurance.vue?vue&type=script&lang=js&"
export * from "./constructionInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports